import dashboard from './dashboard/index.js';
import gridLayout from './grid-layout';
import masonryView from './masonry';
import tabView from './tabview';
class Views {
  constructor() {
    // collection of all available view types, that is their index.js file content
    const VIEW_INDICES = [gridLayout, dashboard, masonryView, tabView];

    this.byLayoutName = {};
    // Setup map of views by layout
    VIEW_INDICES.forEach((viewIndex) => (this.byLayoutName[viewIndex.layout] = viewIndex));
  }
  isViewImplemented(layout) {
    return this.byLayoutName[layout] !== undefined;
  }
  /**
   * Returns the index object (index.js in view) of the view with the given viewType
   * @param {*} layout Name of the view, e.g. GridLayout
   */
  getImplementedViewIndex(layout) {
    return this.byLayoutName[layout];
  }

  getViewRoutes(path, layout, viewConfig, configIdentifier) {
    return this.byLayoutName[layout] ? this.byLayoutName[layout].routeBuilder({ path, viewConfig, configIdentifier }) : [];
  }
}
export default new Views();
